/**
 * Indica si la aplicación se está ejecutando en un entorno diferente al de producción.
 *
 * Si el código se ejecuta fuera del navegador (por ejemplo, durante SSR),
 * se considera un entorno de desarrollo.
 *
 * @returns {boolean} `true` cuando la aplicación no se ejecuta sobre el dominio de producción.
 */
export const isDevelopment = () => {
    if (typeof window === "undefined") {
        return true;
    }

    return window.location.origin !== "https://makemake.com.co";
};